/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { RaceProgressionData, SanctioningBodyEnum } from 'models/viewModels';
import { StreamRequestType } from './RSocketObject';
import { RSocketStreamBaseService } from './RSocketStreamBaseService';

class RaceProgressionService extends RSocketStreamBaseService<RaceProgressionData, RaceProgressionData> {
  protected getStreamHistoryRequest(): Promise<RaceProgressionData | undefined> {
    return Promise.resolve(undefined);
  }

  protected onDataCallback = (response: RaceProgressionData) => {
    if (response && this.listeners.size > 0) {
      this.listeners.forEach((listener) => listener(response));
    }
  };
}

export const raceProgressionService: Map<SanctioningBodyEnum, RaceProgressionService> = new Map(
  (Object.values(SanctioningBodyEnum) as SanctioningBodyEnum[])
    .filter((x) => typeof x === 'number')
    .map((sanctioningBody) => [
      sanctioningBody,
      new RaceProgressionService({
        route: 'stream.raceProgression',
        connectionType: StreamRequestType.MotorsportsStreamApi,
        originType: undefined,
        sanctioningBody: sanctioningBody,
      }),
    ])
);
